import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import CarrierCard from './CarrierCard';
import { carrierCardStyles } from './styles';
import AddOrEditCarrier from './AddOrEditCarrier';

export default function CarriersList() {
  const [isLoading, setIsLoading] = useState(false);
  const [carriers, setCarriers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewCarrierModalOpen, setAddNewCarrierModalOpen] = useState(false);

  const getCarriers = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/carrier/?search=${searchText}`)
      .then(res => {
        setCarriers(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewCarrierModalClose = () => {
    getCarriers();
    setAddNewCarrierModalOpen(false);
  };

  useEffect(() => {
    // Fetch carriers on mount
    getCarriers();
  }, [getCarriers]);

  return (
    <>
      <SearchBar label="Search a carrier..." setQuery={setSearchText} />
      <div style={carrierCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewCarrierModalOpen(true)}>
          Carrier
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={carriers}
            emptyMessage="No carriers found."
            // @ts-ignore
            CardComponent={CarrierCard}
            onCarrierDelete={getCarriers}
            onCarrierUpdate={getCarriers}
          />
          <AddOrEditCarrier
            onSave={onNewCarrierModalClose}
            modalTitle="Add new carrier"
            isModalOpen={addNewCarrierModalOpen}
            setModalOpen={setAddNewCarrierModalOpen}
          />
        </>
      )}
    </>
  );
}
